import api from './api';

export interface Client {
  id: number;
  first_name: string;
  last_name: string;
  profile: string;
  company: string;
  email: string;
  phone_no: string;
  status: boolean;
  customer_id: string;
  created_at: string;
  updated_at: string;
}

export interface ClientCreateInput {
  first_name: string;
  last_name: string;
  profile: string;
  company: string;
  email: string;
  phone_no: string;
  customer_id?: string;
}

export interface ClientUpdateInput extends Partial<ClientCreateInput> {
  id: number;
}

const clientsService = {
  getClients: async (userId: string) => {
    const response = await api.get(`/clients/${userId}`);
    return response.data;
  },

  getClientById: async (id: number, userId: string) => {
    const response = await api.get(`/clients/${id}/${userId}`);
    return response.data;
  },

  createClient: async (clientData: any) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  updateClient: async (clientData: any) => {
    const response = await api.put(`/clients/${clientData.user_id}`, clientData);
    return response.data;
  },

  deleteClient: async (id: number, userId: string) => {
    const response = await api.delete(`/clients/${id}/${userId}`);
    return response.data;
  },

  searchClients: async (userId: number, query: string) => {
    const response = await api.get(`/customers/search/${userId}?query=${query}`);
    return response.data;
  },

  getRoles: async () => {
    const response = await api.get('/users/roles');
    return response.data;
  },

  getPositions: async () => {
    const response = await api.get('/users/positions');
    return response.data;
  },
};

export default clientsService;